import type { Tenant } from '../api/tenants';

/**
 * Participant-count breakdown for a tenant card on the superadmin
 * Dashboard.
 *
 * A suspended tenant has, by definition, no participants with live
 * access — they all inherit the suspension — so active + pending collapse
 * to 0 and everyone reads as suspended. For a live tenant: active =
 * signed-in, pending = added-but-not-signed-in, and whatever's left of
 * the total is participant-level suspended.
 */
export function tenantCardCounts(t: Tenant): {
  active: number;
  pending: number;
  suspended: number;
} {
  const active = t.is_active ? t.active_participant_count : 0;
  const pending = t.is_active ? t.pending_participant_count : 0;
  const suspended = t.participant_count - active - pending;
  return { active, pending, suspended };
}
